import { letters } from '@/enums/colors.json';

export default {
  model: 'detailed',
  cards: {
    1: { value: '1', color: letters.red },
    2: { value: '2', color: letters.blue },
    3: { value: '3', color: letters.red },
    4: { value: '4', color: letters.blue },
    5: { value: '5', color: letters.red },
    6: { value: '6', color: letters.blue },
    7: { value: '7', color: letters.red },
    8: { value: '8', color: letters.blue },
    9: { value: '9', color: letters.red },
    10: { value: '10', color: letters.blue }
  }
};
